export var GLOBAL_ACCOUNT_ID_PARAM = "globalAccountId";
export var INVITATION_ID_PARAM = "invitationId";
export var ELLIPSIS = "...";
export var DATE_FORMAT = "dd MMM yyyy";
export var TIME_FORMAT = "HH:mm";
export var DATE_TIME_FORMAT = "".concat(DATE_FORMAT, " ").concat(TIME_FORMAT);
export var FAILED_TO_FETCH_ERR_MESSAGES = [
    "Failed to fetch",
    "Load failed",
    "NetworkError when attempting to fetch resource.", 
];
export var EXTERNAL_PASSPORT_APP_DOMAIN_NAME = "carrierlogistics";

//# sourceMappingURL=index.js.map